/**
 * The statuses a driver sets from the call, in the order they happen. Their
 * words are callStatusLabel's, the same as the list and the call's header.
 */
export const DRIVER_CALL_STATUSES = [
  'NEW',
  'DISPATCHED',
  'ON_SCENE',
  'TOWING',
  'COMPLETED',
] as const;

const UNSTARTED: ReadonlySet<string> = new Set([
  'OFFERED',
  'ACCEPTED_AWAITING',
  'NEW',
  'PENDING',
]);

/** Not started: the call waits for its driver to start it. */
export const isUnstarted = (status: string): boolean => UNSTARTED.has(status);

const ENDED: ReadonlySet<string> = new Set(['COMPLETED', 'CANCELED']);

/** Under way: started, and neither completed nor cancelled. */
export const isUnderWay = (status: string): boolean =>
  !isUnstarted(status) && !ENDED.has(status);
